"use client"

import React, { useState, useRef, useEffect } from "react"
import { cn } from "@/lib/utils"
import { Button } from "@/components/ui/button"
import { ChevronDown, LogOut, Menu, X, Wallet, Plus } from "lucide-react"
import { useNavigate } from "react-router-dom"
import { useAuth } from "@/context/AuthContext"
import { API_BASE_URL } from "@/lib/api"
import { Input } from "@/components/ui/input"
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogDescription } from "@/components/ui/dialog"
import { useToast } from "@/hooks/use-toast"

// Add isAdmin prop
interface NavigationMenuProps {
  isMobileMenuOpen: boolean
  setIsMobileMenuOpen: (open: boolean) => void
  isAdmin?: boolean
}

interface CustomDropdownProps {
  trigger: React.ReactNode
  children: React.ReactNode
  className?: string
}

function CustomDropdown({ trigger, children, className }: CustomDropdownProps) {
  const [isOpen, setIsOpen] = useState(false)
  const dropdownRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false)
      }
    }

    document.addEventListener("mousedown", handleClickOutside)
    return () => {
      document.removeEventListener("mousedown", handleClickOutside)
    }
  }, [])

  return (
    <div className="relative" ref={dropdownRef}>
      <div onClick={() => setIsOpen(!isOpen)}>{trigger}</div>
      {isOpen && (
        <div
          className={cn(
            "absolute top-full left-0 mt-1 bg-red-800 text-white rounded-md shadow-lg z-50 min-w-[200px]",
            className,
          )}
        >
          {children}
        </div>
      )}
    </div>
  )
}

interface DropdownItemProps {
  onClick: () => void
  children: React.ReactNode
}

function DropdownItem({ onClick, children }: DropdownItemProps) {
  return (
    <div
      className="px-4 py-2 hover:bg-red-700 cursor-pointer text-white first:rounded-t-md last:rounded-b-md"
      onClick={onClick}
    >
      {children}
    </div>
  )
}

export function NavigationMenu({ isMobileMenuOpen, setIsMobileMenuOpen }: NavigationMenuProps) {
  const navigate = useNavigate()
  const { user, logout } = useAuth()
  const { toast } = useToast()
  const [balance, setBalance] = useState<number>(0)
  const [loading, setLoading] = useState(false)
  const [depositAmount, setDepositAmount] = useState("")
  const [showDepositDialog, setShowDepositDialog] = useState(false)

  // Fetch user balance
  const fetchBalance = async () => {
    try {
      const token = localStorage.getItem('auth_token')
      const response = await fetch(`${API_BASE_URL}/wallet/balance`, {
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      })

      if (response.ok) {
        const data = await response.json()
        setBalance(data.balance || 0)
      }
    } catch (error) {
      console.error('Error fetching balance:', error)
    }
  }

  // Handle deposit
  const handleDeposit = async () => {
    const amount = parseFloat(depositAmount)
    if (!amount || amount <= 0 || isNaN(amount)) {
      toast({
        title: "Invalid Amount",
        description: "Please enter a valid deposit amount greater than 0.",
        variant: "destructive",
      })
      return
    }

    setLoading(true)
    try {
      const token = localStorage.getItem('auth_token')
      console.log(token)
      console.log(`${API_BASE_URL}/wallet/depost`)
      console.log({ amount })
      const response = await fetch(`${API_BASE_URL}/wallet/depost`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ amount }),
      })

      const data = await response.json()

      if (response.ok) {
        setBalance(data.balance)
        setDepositAmount("")
        setShowDepositDialog(false)
        toast({
          title: "Deposit Successful",
          description: `₹${amount} has been added to your wallet.`,
          variant: "default",
        })
        // Refresh balance
        fetchBalance()
      } else {
        toast({
          title: "Deposit Failed",
          description: data.error || "Failed to deposit amount.",
          variant: "destructive",
        })
      }
    } catch (error) {
      console.error('Error depositing amount:', error)
      toast({
        title: "Deposit Failed",
        description: "Network error occurred. Please try again.",
        variant: "destructive",
      })
    } finally {
      setLoading(false)
    }
  }

  // Handle logout
  const handleLogout = () => {
    logout()
    navigate("/DearLottery")
    setIsMobileMenuOpen(false)
  }

  // Format currency
  const formatCurrency = (amount: number) => {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(user?.referralCode != null? (amount + 4) : amount)
  }

  // Fetch balance on component mount and when user changes
  useEffect(() => {
    if (user) {
      fetchBalance()
    }
  }, [user])

  const renderNavItems = (isMobile: boolean) => (
    <>
      {/* {["Single", "Rajshree", "Choice"].map((item) => ( */}
      {/* {["Choice"].map((item) => (
        <CustomDropdown
          key={item}
          trigger={
            <Button
              variant="ghost"
              className={cn(
                "text-white hover:bg-red-700 px-3 py-1 rounded-md",
                isMobile && "w-full justify-center py-2",
              )}
            >
              {item} <ChevronDown className="ml-1 h-4 w-4" />
            </Button>
          }
        >
          <DropdownItem onClick={() => {
            navigate(`/DearLottery/${item.toLowerCase()}/add-${item.toLowerCase()}`)
            setIsMobileMenuOpen(false)
          }}>
            Add {item}
          </DropdownItem>
          <DropdownItem onClick={() => {
            navigate(`/DearLottery/${item.toLowerCase()}/${item.toLowerCase()}-list`)
            setIsMobileMenuOpen(false)
          }}>
            {item} List
          </DropdownItem>
        </CustomDropdown>
      ))} */}
 <CustomDropdown
          key={"Choice"}
          trigger={
            <Button
              variant="ghost"
              className={cn(
                "text-white hover:bg-red-700 px-3 py-1 rounded-md",
                isMobile && "w-full justify-center py-2",
              )}
            >
             Choice <ChevronDown className="ml-1 h-4 w-4" />
            </Button>
          }
        >
          <DropdownItem onClick={() => {
            navigate(`/DearLottery/${"Choice".toLowerCase()}/add-${"Choice".toLowerCase()}`)
            setIsMobileMenuOpen(false)
          }}>
            Add {"Choice"}
          </DropdownItem>
          <DropdownItem onClick={() => {
            navigate(`/DearLottery/${"Choice".toLowerCase()}/${"Choice".toLowerCase()}-list`)
            setIsMobileMenuOpen(false)
          }}>
            {"Choice"} List
          </DropdownItem>
        </CustomDropdown>
      <CustomDropdown
        trigger={
          <Button
            variant="ghost"
            className={cn("text-white hover:bg-red-700 px-3 py-1 rounded-md", isMobile && "w-full justify-center py-2")}
          >
            Result <ChevronDown className="ml-1 h-4 w-4" />
          </Button>
        }
      >
        <DropdownItem onClick={() => {
          navigate("/DearLottery/result/dear-single-result")
          setIsMobileMenuOpen(false)
        }}>
          Dear Single Result
        </DropdownItem>
        <DropdownItem onClick={() => {
          navigate("/DearLottery/result/rajshree-punjab-result")
          setIsMobileMenuOpen(false)
        }}>
          Rajshree Punjab Result
        </DropdownItem>
      </CustomDropdown>

      <CustomDropdown
        trigger={
          <Button
            variant="ghost"
            className={cn("text-white hover:bg-red-700 px-3 py-1 rounded-md", isMobile && "w-full justify-center py-2")}
          >
            Report <ChevronDown className="ml-1 h-4 w-4" />
          </Button>
        }
      >
        <DropdownItem onClick={() => {
          navigate("/DearLottery/report/dear-single-winning-report")
          setIsMobileMenuOpen(false)
        }}>
          Dear Single Winning Report
        </DropdownItem>
        <DropdownItem onClick={() => {
          navigate("/DearLottery/report/rajshree-punjab-winning-report")
          setIsMobileMenuOpen(false)
        }}>
          Rajshree Punjab Winning Report
        </DropdownItem>
        <DropdownItem onClick={() => {
          navigate("/DearLottery/report/choice-winning-report")
          setIsMobileMenuOpen(false)
        }}>
          Choice Winning Report
        </DropdownItem>
        <DropdownItem onClick={() => {
          navigate("/DearLottery/report/choice-customer-report")
          setIsMobileMenuOpen(false)
        }}>
          Choice Customer Report
        </DropdownItem>
        {/* <DropdownItem onClick={() => {
          navigate("/DearLottery/news")
          setIsMobileMenuOpen(false)
        }}>
          News
        </DropdownItem> */}
      </CustomDropdown>
{/* 
      <Button
        variant="ghost"
        className={cn("text-white hover:bg-red-700 px-3 py-1 rounded-md", isMobile && "w-full justify-center py-2")}
        onClick={() => {
          navigate("/DearLottery/password-change")
          setIsMobileMenuOpen(false)
        }}
      >
        Profile
      </Button> */}
    </>
  )

  return (
    <>
      {/* Desktop navigation */}
      {/* <nav className="hidden sm:flex gap-6 text-sm items-center">{renderNavItems(false)}</nav> */}

      {/* Balance and Actions for desktop */}
      <div className="hidden sm:flex items-center gap-4">
        <div className="flex items-center gap-2 bg-green-600 text-white px-3 py-1 rounded-md">
          <Wallet className="h-4 w-4" />
          <span className="font-semibold">{formatCurrency(balance)}</span>
        </div>
        
        <Dialog open={showDepositDialog} onOpenChange={setShowDepositDialog}>
          <DialogTrigger asChild>
            <Button 
              variant="ghost" 
              size="sm"
              className="text-white hover:bg-green-700 bg-green-600"
              onClick={() => setShowDepositDialog(true)}
            >
              <Plus className="h-4 w-4 mr-1" />
              Deposit
            </Button>
          </DialogTrigger>
          <DialogContent className="sm:max-w-md bg-white" onInteractOutside={(e) => e.preventDefault()}>
            <DialogHeader>
              <DialogTitle>Deposit Money</DialogTitle>
              <DialogDescription>
                Enter the amount you want to deposit into your wallet.
              </DialogDescription>
            </DialogHeader>
            <div className="space-y-4">
              <div>
                <label className="text-sm font-medium">Amount (₹)</label>
                <Input
                  type="number"
                  placeholder="Enter amount"
                  value={depositAmount}
                  onChange={(e) => setDepositAmount(e.target.value)}
                  className="mt-1"
                  min="1"
                  step="1"
                />
              </div>
              <div className="flex justify-end space-x-2">
                <Button
                  variant="outline"
                  onClick={() => {
                    setShowDepositDialog(false)
                    setDepositAmount("")
                  }}
                >
                  Cancel
                </Button>
                <Button
                  onClick={handleDeposit}
                  disabled={loading || !depositAmount || parseFloat(depositAmount) <= 0}
                  className="bg-green-600 hover:bg-green-700"
                >
                  {loading ? "Processing..." : "Deposit"}
                </Button>
              </div>
            </div>
          </DialogContent>
        </Dialog>

        {/* <Button variant="ghost" size="icon" className="text-white hover:bg-red-700" onClick={handleLogout}>
          <LogOut className="h-5 w-5" />
          <span className="sr-only">Logout</span>
        </Button> */}
      </div>

      {/* Hamburger menu button for mobile */}
      <Button
        variant="ghost"
        size="icon"
        className="text-white hover:bg-red-700 sm:hidden"
        onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
      >
        {isMobileMenuOpen ? <X className="h-10 w-10" /> : <Menu className="h-6 w-6" />}
        <span className="sr-only">Toggle menu</span>
      </Button>
      {/* Mobile drawer */}
      <div
        className={cn(
          "fixed top-0 left-0 h-full w-64 bg-red-800 text-white shadow-lg z-50 transform transition-transform duration-300 ease-in-out",
          isMobileMenuOpen ? "translate-x-0" : "-translate-x-full",
          "sm:hidden"
        )}
      >
        <div className="flex flex-col gap-4 p-4 border-b border-red-700">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2 bg-green-600 text-white px-3 py-1 rounded-md">
              <Wallet className="h-4 w-4" />
              <span className="font-semibold">{formatCurrency(balance)}</span>
            </div>
            {/* <Button variant="ghost" size="icon" className="text-white hover:bg-red-700" onClick={handleLogout}>
              <LogOut className="h-5 w-5" />
              <span className="sr-only">Logout</span>
            </Button> */}
          </div>
          
          <Button 
            variant="ghost"
            className="text-white hover:bg-green-700 bg-green-600 w-full justify-center"
            onClick={() => setShowDepositDialog(true)}
          >
            <Plus className="h-4 w-4 mr-1" />
            Deposit Money
          </Button>
        </div>
        <nav className="flex flex-col gap-4 p-4">{renderNavItems(true)}</nav>
      </div>

      {/* Backdrop to close drawer on outside click */}
      {isMobileMenuOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-40 sm:hidden"
          onClick={() => setIsMobileMenuOpen(false)}
        />
      )}
    </>
  )
}